import { render, staticRenderFns } from "./BrowseProduct.vue?vue&type=template&id=daf0aede&scoped=true&"
import script from "./BrowseProduct.vue?vue&type=script&lang=ts&"
export * from "./BrowseProduct.vue?vue&type=script&lang=ts&"
import style0 from "./BrowseProduct.vue?vue&type=style&index=0&id=daf0aede&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daf0aede",
  null
  
)

export default component.exports